import { RowSelectionState } from "@tanstack/react-table";
import { useState } from "react";

export const useRowSelection = () => {
  const [rowSelection, setRowSelection] = useState<RowSelectionState>({});

  return [rowSelection, setRowSelection] as const;
};
